export default "__VITE_PUBLIC_ASSET__37c8bd10__"